__turbopack_context__.v({
  "container": "styles-module__Ttx8dq__container",
  "content": "styles-module__Ttx8dq__content",
  "image": "styles-module__Ttx8dq__image",
  "reverse": "styles-module__Ttx8dq__reverse",
  "segment": "styles-module__Ttx8dq__segment",
  "title": "styles-module__Ttx8dq__title",
});
